import "../css/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ResidentialMortgagesPage from "./pages/ResidentialMortgages";
import BuytoLetMortgagesPage from "./pages/BuytoLetMortgages";
import SpecialistLendingPage from "./pages/SpecialistLending";
import OtherServicesPage from "./pages/OtherServices";
import ProtectionPage from "./pages/Protection";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./designSystem/Navbar";
import Footer from "./designSystem/Footer";
import ScrollToTop from "./designSystem/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import MortgageRepaymentCalculatorsPage from "../frontend/pages/calculators/MortgageRepaymentPage";
import ContactUsComponent from "./components/ContactUsComponent";
import AboutUsPage from "./pages/AboutUs";
import MortgageCalculatorsPage from "./pages/MortgageCalculators";
import MortgageBorrowPage from "./pages/calculators/MortgageBorrowPage";
import StampDutyPage from "./pages/calculators/StampDutyPage";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          {/* Navbar can be added here if needed */}
          {/* Define application routes */}
          <Routes>
            {/* Home page route */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route
              path="/mortgage-calculators"
              element={<MortgageCalculatorsPage />}
            />
            <Route
              path="/calculators/mortgage-borrow"
              element={<MortgageBorrowPage />}
            />
            <Route
              path="/calculators/mortgage-repayment"
              element={<MortgageRepaymentCalculatorsPage />}
            />
            <Route
              path="/calculators/stamp-duty"
              element={<StampDutyPage />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/other-services" element={<OtherServicesPage />} />
            <Route path="/residential-mortgages" element={<ResidentialMortgagesPage />} />
            <Route path="/buy-to-let-mortgages" element={<BuytoLetMortgagesPage />} />
            <Route path="/specialist-lending" element={<SpecialistLendingPage />} />
            <Route path="/protection" element={<ProtectionPage />} />
         
         
            <Route path="*" element={<LandingPage />} />
            
            
            
            {/* <Route path="/blogs" element={<BlogsPage />} /> */}
          </Routes>
          <ContactUsComponent />
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
